import React, { useState, useEffect } from 'react';
import logo from '../assets/Logo.png';  // Importa el logo
import avatar from '../assets/Avatar.png';

const Header = () => {

  const [isScrolled, setIsScrolled] = useState(false);
  const handleScroll = () => {
    if (window.scrollY > 25) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <img src={avatar} alt="Logo" className="avatar" />
        <img src={logo} alt="Logo" className="logo" />  {/* Mostrar el logo */}
      <div className="title-container">
        <toptitle>Framegonz</toptitle><subtitle>- Servicios Informáticos -</subtitle>
      </div>
    </header>
  );
};

export default Header;